/**
 * Hier werden Dienste aufgelistet die in einem der Module
 * im /shared-Verzeichnis sind und für Angular (unbedingt) verfügbar sein sollen.
 *
 * Zugleich ist es auch eine ToDo-Liste für Services die höchstwahrscheinlich
 * zuletzt migriert werden.
 */
angular
.module("impactx.z")
.service("ContextService", [
    "$context",
    "dataGen",
    function ($context, dataGen) {
        this.getUserIdValue = function () {
            return $context.userId.value;
        };

        this.setComIdForThemes = function (value) {
            $context.comIdForThemes.value = value;
        };

        this.refreshBasket = function (arg) {
            return $context.refreshBasket(arg, dataGen, $context);
        };

        this.hasActiveThemeWorldSearch = function () {
            return (
                $context.hasActiveThemeWorldSearch &&
                $context.hasActiveThemeWorldSearch.value
            );
        };

        this.hasActiveProductView = () => {
            return $context.hasActiveProductView ? $context.hasActiveProductView : undefined
        }

        this.hasActiveThemeWorld = () => {
            return $context.hasActiveThemeWorld ? $context.hasActiveThemeWorld : undefined
        }
        this.hasSupplierBasket = () => {
            return $context.hasSupplierBasket ? $context.hasSupplierBasket : undefined
        }

        this.companyId = () => {
            return $context.companyId();
        }

        this.showSupplierBasket = () => {
            return $context.showSupplierBasket ? $context.showSupplierBasket.value : false;
        }

        this.uniteOptimizationRunning = () => {
            return !!$context.uniteOptimizationRunning;
        }

        this.refreshSearchInfo = (data) => {
            return $context.refreshSearchInfo(data, dataGen, $context)
        }
        this.neededDataInput = () => {
            return $context.neededDataInput
        }
        this.setNeededDataInput = (data) => {
            $context.setNeededDataInput(data);
        }
    },
])
.service("ConfigService", [
    "$config",
    "$mdTheming",
    function ($config, $mdTheming) {
        this.getSourceURL = function () {
            return $config.sourceURL;
        };

        this.getBaseURL = function () {
            return $config.baseURL;
        };

        this.getTinyMceOptions = function () {
            return $config.tinymceOptions;
        };

        this.getCustomThemes = function () {
            return ($config.customThemes || []).map(function (name) {
                var hex = ($mdTheming.PALETTES[name] && $mdTheming.PALETTES[name][500] && $mdTheming.PALETTES[name][500].hex) || '1976D2';
                return { name: name, color: '#' + hex };
            });
        };
    },
])
.service("SidebarService", [
    "sidebarShow",
    function (sidebarShow) {
        this.openSidebar = () => {
            sidebarShow.open();
        }
        this.setMenuToggleIsHidden = (value) => {
            sidebarShow.setToggleIsHidden(value);
        }
    },
])
.service("SecurityManagerService", [
    "$securityManager",
    function ($securityManager) {
        this.getToken = function () {
            return $securityManager.getToken();
        };

        this.setToken = function (token) {
            return $securityManager.setToken(token);
        };

        this.isSuperUser = function () {
            return $securityManager.isSuperUser();
        };

        this.isInitialized = function () {
            return $securityManager.isInitialized;
        };

        this.isProcessAllowed = function (processName) {
            return $securityManager.isProcessAllowed(processName);
        };

        this.isAuthorized = function () {
            return $securityManager.isAuthorized();
        };

        this.invalidateProcesses = function () {
            $securityManager.invalidateProcesses()
        };
    },
])
.service("AngularSharedMigrationService", [
    "AppConfiguration",
    "ConfigService",
    "ConfirmationService",
    "ContextService",
    "dataGen",
    "$errorHandler",
    "$listCache",
    "ListPrintService",
    "LoadingDialogService",
    "OpenGovernmentDataService",
    "SecurityManagerService",
    "ToolbarService",
    "TranslationService",
    "WarningService",
    "$workspace",
    "ProductViewService",
    "ThemeWorldService",
    "AddToBasketService",
    "panelService",
    "OCICatalogService",
    "ProductSelectionService",
    'OutsourcedCommentSaveService',
    'SidebarService',
    '$mdDialog',
    'SmartFormService',
    'SmartFormTemplateCache',
    function (AppConfiguration, ConfigService, ConfirmationService, ContextService, dataGen, $errorHandler, $listCache,
              ListPrintService, LoadingDialogService, OpenGovernmentDataService, SecurityManagerService, ToolbarService,
              TranslationService, WarningService, $workspace, ProductViewService, ThemeWorldService, AddToBasketService, panelService,
              OCICatalogService, ProductSelectionService, OutsourcedCommentSaveService, SidebarService, $mdDialog,
              SmartFormService, SmartFormTemplateCache) {
        ixTryRegisterService("AppConfiguration", AppConfiguration);
        ixTryRegisterService("ConfigService", ConfigService);
        ixTryRegisterService("ConfirmationService", ConfirmationService);
        ixTryRegisterService("ContextService", ContextService);
        ixTryRegisterService("dataGen", dataGen);
        ixTryRegisterService("$errorHandler", $errorHandler);
        ixTryRegisterService("ListCacheService", $listCache);
        ixTryRegisterService("ListPrintService", ListPrintService);
        ixTryRegisterService("LoadingDialogService", LoadingDialogService);
        ixTryRegisterService("OpenGovernmentDataService", OpenGovernmentDataService);
        ixTryRegisterService("SecurityManagerService", SecurityManagerService);
        ixTryRegisterService("ToolbarService", ToolbarService);
        ixTryRegisterService("TranslationService", TranslationService);
        ixTryRegisterService("WarningService", WarningService);
        ixTryRegisterService("$workspace", $workspace);
        ixTryRegisterService("ProductViewService", ProductViewService)
        ixTryRegisterService("ThemeWorldService", ThemeWorldService)
        ixTryRegisterService("AddToBasketService", AddToBasketService)
        ixTryRegisterService("panelService", panelService)
        ixTryRegisterService("OCICatalogService", OCICatalogService)
        ixTryRegisterService("ProductSelectionService", ProductSelectionService)
        ixTryRegisterService("OutsourcedCommentSaveService", OutsourcedCommentSaveService)
        ixTryRegisterService("SidebarService", SidebarService)
        ixTryRegisterService("$mdDialog", $mdDialog)
        ixTryRegisterService("SmartFormService", SmartFormService)
        ixTryRegisterService("SmartFormTemplateCache", SmartFormTemplateCache)
        this.hasLoadedServices = function () {
            return true;
        };
    },
]);
